// Sovereign Link Health & 404 Sentinel Scanner
// Heuristically evaluates URL structural integrity, protocol encryption, and tracking clutter

export function auditBookmarkHealth(items = []) {
  const results = {
    healthy: [],
    insecureHttp: [],
    malformed: [],
    clutteredTracking: [],
    total: 0,
    healthScore: 100,
  };

  const linkItems = items.filter((i) => i && i.type === 'link' && i.url);
  results.total = linkItems.length;

  if (results.total === 0) return results;

  const trackingParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'gclid', 'ref'];

  for (const item of linkItems) {
    try {
      const parsed = new URL(item.url);

      // Check protocol
      if (parsed.protocol === 'http:') {
        results.insecureHttp.push({
          item,
          issue: 'Unencrypted HTTP protocol',
          suggestion: 'Upgrade to HTTPS',
          fixedUrl: item.url.replace(/^http:\/\//i, 'https://'),
        });
        continue;
      }

      if (parsed.protocol !== 'https:' && parsed.protocol !== 'chrome-extension:') {
        results.malformed.push({
          item,
          issue: `Unsupported protocol: ${parsed.protocol}`,
          suggestion: 'Verify destination URL',
        });
        continue;
      }

      // Check tracking clutter
      let hasTracking = false;
      for (const p of trackingParams) {
        if (parsed.searchParams.has(p)) {
          hasTracking = true;
          break;
        }
      }

      if (hasTracking) {
        const cleanUrl = new URL(item.url);
        trackingParams.forEach((tp) => cleanUrl.searchParams.delete(tp));
        results.clutteredTracking.push({
          item,
          issue: 'Embedded tracking telemetry parameters',
          suggestion: 'Strip telemetry parameters',
          fixedUrl: cleanUrl.toString(),
        });
        continue;
      }

      results.healthy.push(item);
    } catch (err) {
      results.malformed.push({
        item,
        issue: 'Malformed or unparseable URL string',
        suggestion: 'Edit or remove bookmark',
      });
    }
  }

  const issueCount = results.insecureHttp.length + results.malformed.length + results.clutteredTracking.length;
  results.healthScore = Math.max(0, Math.round(((results.total - issueCount) / results.total) * 100));

  return results;
}
